import {ROUTES} from "./constants";

export const navigateToUserHome = (navigate: any) =>
    navigate(ROUTES.USER_HOME);